module.exports = __webpack_public_path__ + "img/about.b57a9a31.png";